import FilledButton from "../../../component/FilledButton";
import { Form } from "antd";
import { useEffect } from "react";

const SearchPop = ({ search, setSearch, setModalOpen, filteredPosts }) => {
    const [form] = Form.useForm();
    useEffect(() => {
        setSearch({ title: '' })
        form.resetFields()
    }, [filteredPosts])
    return (
        <div className="modal_body">
            <Form
                form={form}
                name="register"
                onFinish={(e) => { setSearch(e, form); setModalOpen(false); }}
                onReset={() => { setModalOpen(false); setSearch({ title: '' }) }}
                initialValues={search}
                className="attached_courses-add_skill search_modal"
            >
                <h2>Search Thought Leader</h2>
                <Form.Item name="title" className="form_group">
                    <input name="name" value={search.title} type="text" className="form_control" autoComplete='off' autoFocus />
                </Form.Item>
                <div className="form_group form_footer">
                    <FilledButton type="reset" className="btn btn_gray" value="Cancel" />
                    <FilledButton type="submit" className="btn btn_primary" value="Search" />
                </div>
            </Form>
        </div>
    )
};

export default SearchPop;